import { Button, ConfigProvider, notification } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationSound } from 'hooks/useNotificationSound/useNotificationSound';
import { InfoCircleFilled } from '@ant-design/icons';
import classes from './AllowNewMessageSound.module.scss'
import { useAppSelector } from 'store/hook';

const AllowNewMessageSound = () => {
  const [show, contextHolder] = notification.useNotification();
  const { i18n, t } = useTranslation();

  const { soundNotificationState, playChatNotification } = useAppSelector((store) => store.windowState);
  
  const { enableSound, playSound, disableSound } = useNotificationSound();

  const allowSound = () => {
    enableSound();
    show.destroy();
  };

  const closeNotification = () => {
    show.destroy();
    disableSound();
  };

  React.useEffect(() => {
    if (playChatNotification) {
      playSound();
    }
  }, [playChatNotification]);

  React.useEffect(() => {
    if (!soundNotificationState?.enabled && soundNotificationState.open) {
      show.destroy(); // необходимо для корректной смены языка
      setTimeout(() => {
        show.open({
          message: <div className={classes.title}>{t('soundNotification.title')}</div>,
          description: (
            <div className={classes.text}>
              {t('soundNotification.text')}
              <div className={classes.btnGroup}>
                <Button style={{marginRight: 10, flex: 3 }} type='primary' onClick={allowSound}>
                  {t('soundNotification.allow')}
                </Button>

                <Button style={{flex: 2 }} onClick={closeNotification}>
                  {t('soundNotification.later')}
                </Button>
              </div>
            </div>
          ),
          placement: 'topRight',
          duration: 0,
          style: { padding: '16px' },
          icon: <InfoCircleFilled className={classes.infoIcon} />
        });
      }, 1);
    };
  }, [i18n.language, soundNotificationState.open]);

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Notification: {
              width: 500
            },
          },
        }}
      >
        {contextHolder}
      </ConfigProvider>
      {/* // Проверки показали что это метод ненадёжный, возможно можно доработать */}
      {/* <button onClick={enableSound} id={'allowSoundBtn'} style={{display: 'none'}}>allow sound</button> */}
    </>
  );
}

export default AllowNewMessageSound;
